export const PEU_ROUTE = 'peu';
export const PEU_PAYMENT_PAGE_PARAMETRIZED = 'platnosc/:id';
export const PEU_PAYMENT_PAGE = 'platnosc';
export const PEU_PAYMENT_CONFIRMATION_PARAMETRIZED = 'potwierdzenie/:id';
export const PEU_PAYMENT_CONFIRMATION = 'potwierdzenie';
